<template>
  <v-app>
    <keep-alive :include="['CampaignDetails', 'CompanyDetails']">
      <router-view/>
    </keep-alive>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

export default {
  computed: {
    ...mapGetters(['isWhiteLabel']),
  },
  created() {
    // if (!this.isWhiteLabel) {
    //   const jiraServiceDesk = document.createElement('script');
    //   jiraServiceDesk.setAttribute('data-jsd-embedded',"");
    //   jiraServiceDesk.setAttribute('async',"");
    //   jiraServiceDesk.setAttribute('data-key',"8bb1d566-19d3-4b9c-ad95-b7d781019a64");
    //   jiraServiceDesk.setAttribute('data-base-url',"https://jsd-widget.atlassian.com");
    //   jiraServiceDesk.setAttribute('src',"https://jsd-widget.atlassian.com/assets/embed.js");
    //   document.head.appendChild(jiraServiceDesk);
    // }
  }
};
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import 'assets/scss/style.scss';
@import 'assets/scss/colors/default.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue